import { useState, useEffect } from 'react';
import { TableColumnDefinition } from '@antimatterhq/ui/types/TableColumnDefinition';

// This is a hook that returns a stable hash of the column definitions
export function useStableTableKey(
  columnDefinitions: TableColumnDefinition[],
  localStorageKeyPrefix: string,
) {
  const [hash, setHash] = useState<string>('');

  useEffect(() => {
    const calculateHash = async () => {
      const hashBuffer = await window.crypto.subtle.digest(
        'SHA-256',
        new TextEncoder().encode(JSON.stringify(columnDefinitions)),
      );

      // Convert to hex string
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('');

      setHash(hashHex);
    };

    calculateHash();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return hash ? `${localStorageKeyPrefix}-${hash}` : '';
}
